module.exports = __webpack_public_path__ + "img/symbol_6.e8ade6ae.png";